import React from 'react';

function FilesInput({id, name, label, files, onChange, onRemoveFile, error=null, fileAccepted="image/*"}) {

  return (
    <div className="mb-2">
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <div className="mt-1 rounded-lg border border-gray-200 bg-white p-4">
        <label
          htmlFor={id}
          className="flex cursor-pointer items-center justify-between rounded-lg border border-dashed border-gray-300 bg-gray-50 px-4 py-3 transition hover:border-primary hover:bg-primary/5"
        >
          <span className="text-sm font-medium text-gray-700">Selectionner des fichiers</span>
          <span className="rounded-md bg-primary px-3 py-1 text-xs font-semibold text-white">
            Parcourir
          </span>
        </label>
        <input
          id={id}
          name={name}
          type="file"
          accept={fileAccepted}
          onChange={onChange}
          className="hidden"
          multiple={true}
        />

   

        <div className="mt-3 space-y-2">
          {files?.length > 0 ? files.map((file, index) => (
            <div key={index} className="flex items-center justify-between rounded-md border border-gray-200 bg-gray-50 px-3 py-2">
              <p className="truncate pr-3 text-sm text-gray-700">{file.name}</p>
              <button
                type="button"
                onClick={() => onRemoveFile(index)}
                className="rounded px-2 py-1 text-xs font-medium text-red-600 transition hover:bg-red-50 hover:text-red-700"
              >
                Retirer
              </button>
            </div>
          )) : (
            <p className="text-sm text-gray-500">Aucun fichier sélectionné.</p>
          )}
        </div>
      </div>

      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
}

export default FilesInput;